import ObserveErrors from './ObserveErrors';
export default ObserveErrors;



// WEBPACK FOOTER //
// ./src/components/ObserveErrors/index.js